import React from 'react';

const Navigation = ({ scrollToSection }) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="text-2xl font-serif font-bold text-gray-900">Oluwatobi I. Abiola-Adeyemo</div>
        <div className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-[#14b8a6] transition-colors">About</button>
          <button onClick={() => scrollToSection('work')} className="text-gray-700 hover:text-[#14b8a6] transition-colors">Work</button>
          <button onClick={() => scrollToSection('books')} className="text-gray-700 hover:text-[#14b8a6] transition-colors">Books</button>
          <button onClick={() => scrollToSection('speaking')} className="text-gray-700 hover:text-[#14b8a6] transition-colors">Speaking</button>
          <button onClick={() => scrollToSection('global-360-child')} className="text-gray-700 hover:text-[#14b8a6] transition-colors">Global 360° Child</button>
          <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-[#14b8a6] transition-colors">Contact</button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;